<template>
  <div class="page">
    <Banner :top="0" />
    <div class="pc_ipad">
      <div class="layer1">
        <div class="left">
          <div class="row row1">
            <div>
              <img
                src="~@/assets/spark2/1.jpg"
                alt=""
              >
            </div>
            <div class="video">
              <img
                v-if="play1"
                class="play"
                src="~@/assets/spark-mini/play.png"
                alt=""
                @click="videoClick1"
              >
              <video
                ref="videoPlayer1"
                loop
                autoplay
                poster="~@/assets/spark2/2.png"
                @click="videoClick1"
              >
                <source
                  src="https://assets.positivegrid.com.cn/media/1021%E6%AD%A3%E6%96%B9%E5%BD%A2%E7%9A%84%E5%AE%98%E6%96%B9TVC.mp4"
                  type="video/mp4"
                >
              </video>
            </div>
          </div>
          <div class="row row1">
            <div>
              <img src="~@/assets/spark2/3.jpg">
            </div>
            <div>
              <img src="~@/assets/spark2/4.jpg">
            </div>
          </div>
          <div class="row row1">
            <div>
              <img src="~@/assets/spark2/5.jpg">
            </div>
            <div>
              <img src="~@/assets/spark2/6.jpg">
            </div>
          </div>
        </div>
        <div class="right">
          <div class="box">
            <img
              class="background"
              src="~@/assets/spark2/0.png"
            >
            <div class="right_btn_box">
              <!-- <img
                class="price"
                src="~@/assets/spark-live/3999.png"
              > -->
              <img
                class="btn"
                src="~@/assets/spark2/0_1.png"
                @click="openTmallFun"
              >
              <img
                class="btn btn_jd"
                src="~@/assets/spark2/0_2.png"
                @click="openJDFun"
              >
              <div class="download">
                <a
                  :href="androidUrl"
                  download=""
                  style="cursor:pointer"
                  @click="downloadAndroidFun"
                >
                  <img
                    class="anzuo"
                    src="~@/assets/spark2/0_3.png"
                    @click="downloadAndroidFun"
                  >
                </a>
                <img
                  src="~@/assets/spark2/0_4.png"
                  @click="downIosFun"
                >
                <!-- <img
                  class="text"
                  src="~@/assets/spark-mini/text.png"
                > -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="layer2"
        style="padding-top:10%;"
      >
        <img src="~@/assets/spark2/ls2.png">
      </div>

      <div class="layer4">
        <swiper
          class="swiper"
          :options="swiperOption1"
        >
          <swiper-slide class="width" />
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls3/Frame 1848.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls3/Frame 1850.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls3/Frame 1857.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls3/Frame 1858.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls3/Frame 1859.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls3/Frame 1860.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls3/Frame 1861.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls3/Frame 1862.png"
            >
          </swiper-slide>
          <swiper-slide class="width" />

          <!-- <div
          slot="pagination"
          class="swiper-pagination"
        /> -->
        </swiper>
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls4.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls5.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls6.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls7.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls8.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls9.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls10.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls11.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls12.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls13.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls14.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls15.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls16.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls17.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls18.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls19.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls20.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls21.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls23.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls25.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls26.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls29.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls30.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls31.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls32.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls34.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls35.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls36.png">
      </div>
      <div class="layer5">
        <img src="~@/assets/spark2/ls37.png">
        <swiper
          class="swiper"
          :options="swiperOption1mobile"
        >
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls37-1/2noise_gate-1.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls37-1/2noise_gate.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls37-1/bass_muff.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls37-1/bassmaster.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls37-1/booster.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls37-1/chamber-1.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls37-1/chamber.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls37-1/clone_drive.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls37-1/cloner_chorus-1.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls37-1/cloner_chorus.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls37-1/echo_tape.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls37-1/fuzz_face.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls37-1/hall_natural.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls37-1/la_comp.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls37-1/plate_rich.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls37-1/sustain_comp.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls37-1/tremolo.png"
            >
          </swiper-slide>
        </swiper>
        <swiper
          class="swiper swiper2"
          :options="swiperOption1mobile"
        >
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls37-2/02_silver120.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls37-2/03_black duo.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls37-2/ac boost.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls37-2/British 31.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls37-2/JM45.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls37-2/RB 102.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls37-2/Treadplate.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls37-2/W600.png"
            >
          </swiper-slide>
        </swiper>
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls38.png">
      </div>
      <div class="layer4 layer4_1">
        <swiper
          class="swiper"
          :options="swiperOption1"
        >
          <swiper-slide class="width" />
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls39/App item.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls39/App item-1.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls39/App item-2.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls39/App item-3.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls39/App item-4.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls39/App item-5.png"
            >
          </swiper-slide>
          <swiper-slide class="width" />

          <!-- <div
          slot="pagination"
          class="swiper-pagination"
        /> -->
        </swiper>
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls40.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls41.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls42.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls43.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls44.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/ls45.png">
      </div>
      <div class="layer8">
        <img src="~@/assets/spark-live/sec 3.png">
        <swiper
          class="swiper"
          :options="swiperOption2"
        >
          <!-- <swiper-slide class="width" /> -->

          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls46-1/Gallery01.jpg"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls46-1/Gallery02.jpg"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls46-1/Gallery03.jpg"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls46-1/Gallery04.jpg"
            >
          </swiper-slide>

          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls46-1/Gallery05.jpg"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls46-1/Gallery06.jpg"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls46-1/Gallery07.jpg"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls46-1/Gallery08.jpg"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls46-1/Gallery09.jpg"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls46-1/Gallery09-1.jpg"
            >
          </swiper-slide>
        </swiper>
      </div>
      <div class="layer9">
        <img src="~@/assets/spark2/ls47.png">
      </div>
    </div>

    <!-- 手机版 -->
    <div class="mobile">
      <vue-carousel
        :data="slides"
        :slide-on-swipe="false"
        class="carousel"
      />
      <div class="layer2">
        <img src="~@/assets/spark2/mobile/m1.png">
        <div
          class="tmall"
          @click="openTmallFun"
        >
          <img src="~@/assets/spark2/0_1.png">
        </div>
        <div
          class="tmall jd"
          @click="openJDFun"
        >
          <img src="~@/assets/spark2/0_2.png">
        </div>
        <a
          :href="androidUrl"
          download=""
          style="cursor:pointer"
          class="anzuo"
          @click="downloadAndroidFun"
        >
          <img src="~@/assets/spark2/0_3.png">
        </a>
        <a class="ios">
          <img
            src="~@/assets/spark2/0_4.png"
            @click="downIosFun"
          >
        </a>
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/mobile/m2.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/mobile/m3.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/mobile/m4.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/mobile/m5.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/mobile/m6.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/mobile/m7.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/mobile/m8.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/mobile/m9.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/mobile/m10.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/mobile/m11.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/mobile/m12.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/mobile/m13.png">
      </div>
      <div class="layer2 layer14">
        <img src="~@/assets/spark2/mobile/m14.png">
        <swiper
          class="swiper"
          :options="swiperOption1"
        >
          <swiper-slide class="width" />
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls39/App item.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls39/App item-1.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls39/App item-2.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls39/App item-3.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls39/App item-4.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark2/ls39/App item-5.png"
            >
          </swiper-slide>
          <swiper-slide class="width" />
        </swiper>
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/mobile/m15.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/mobile/m16.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/mobile/m17.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark2/mobile/m18.png">
      </div>
      <!-- <div class="swiper1">
        <swiper
          class="swiper"
          :options="swiperOption1"
        >
          <swiper-slide class="width" />
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper1/Frame 1848.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper1/Frame 1850.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper1/Frame 1851.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper1/Frame 1852.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper1/Frame 1853.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper1/Frame 1855.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper1/Frame 1856.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper1/Frame 1857.png"
            >
          </swiper-slide>
        </swiper>
      </div> -->
    </div>
  </div>
</template>
<script>
import Banner from '@/components/banner'
import VueCarousel from '@chenfengyuan/vue-carousel'
import axios from 'axios'
import { NEW_API_URL } from '@/urls'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
  components: {
    Banner,
    VueCarousel,
    swiper,
    swiperSlide
  },
  data () {
    let row1 = require('@/assets/spark2/1.jpg')
    let row2 = require('@/assets/spark2/2.png')
    let row3 = require('@/assets/spark2/3.jpg')
    let row4 = require('@/assets/spark2/4.jpg')
    let row5 = require('@/assets/spark2/5.jpg')
    let row6 = require('@/assets/spark2/6.jpg')
    return {
      play1: false,
      play2: true,
      play5: true,
      play6: false,
      play7: false,
      play8: true,
      slides: [
        `<div> <img src="${row1}" > </div>`,
        `<div> <img src="${row2}" > </div>`,
        `<div> <img src="${row3}" > </div>`,
        `<div> <img src="${row4}" > </div>`,
        `<div> <img src="${row5}" > </div>`,
        `<div> <img src="${row6}" > </div>`
      ],
      androidUrl: '',
      num: 0,
      swiperOption1: {
        slidesPerView: 'auto',
        loop: false,
        spaceBetween: 20,
        // slidesOffsetBefore: '260%',
        freeMode: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      swiperOption2: {
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: false,
        spaceBetween: 20,
        initialSlide: 2, // 滑动在第几个开始
        // freeMode: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      swiperOption1mobile: {
        slidesPerView: 'auto',
        loop: false,
        spaceBetween: 20, // 图片间隔
        freeMode: true,
        initialSlide: 3, // 滑动在第几个开始
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      swiperOption2mobile: {
        slidesPerView: '1.2',
        loop: false,
        spaceBetween: 0,
        freeMode: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      swiperOption2moblie: {
        slidesPerView: '1.3',
        loop: false,
        spaceBetween: 10,
        initialSlide: 3,
        centeredSlides: true,
        freeMode: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  watch: {},
  created () {
    this.downloadAndroidFun()
  },
  methods: {
    videoClick1 () {
      this.play1 = !this.$refs.videoPlayer1.paused

      this.$refs.videoPlayer1.paused === true
        ? this.$refs.videoPlayer1.play()
        : this.$refs.videoPlayer1.pause()
    },
    videoClick2 () {
      this.play2 = !this.$refs.videoPlayer2.paused
      this.$refs.videoPlayer2.paused === true
        ? this.$refs.videoPlayer2.play()
        : this.$refs.videoPlayer2.pause()
    },
    videoClick3 () {
      this.play1 = !this.$refs.videoPlayer3.paused

      this.$refs.videoPlayer3.paused === true
        ? this.$refs.videoPlayer3.play()
        : this.$refs.videoPlayer3.pause()
    },
    videoClick5 () {
      this.play5 = !this.$refs.videoPlayer5.paused

      this.$refs.videoPlayer5.paused === true
        ? this.$refs.videoPlayer5.play()
        : this.$refs.videoPlayer5.pause()
    },
    videoClick6 () {
      this.play6 = !this.$refs.videoPlayer6.paused

      this.$refs.videoPlayer6.paused === true
        ? this.$refs.videoPlayer6.play()
        : this.$refs.videoPlayer6.pause()
    },
    videoClick7 () {
      this.play7 = !this.$refs.videoPlayer7.paused

      this.$refs.videoPlayer7.paused === true
        ? this.$refs.videoPlayer7.play()
        : this.$refs.videoPlayer7.pause()
    },
    videoClick8 () {
      this.play8 = !this.$refs.videoPlayer8.paused

      this.$refs.videoPlayer8.paused === true
        ? this.$refs.videoPlayer8.play()
        : this.$refs.videoPlayer8.pause()
    },
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    openTmallFun () {
      if (this._isMobile()) {
        window.open('http://e.tb.cn/h.gxtSaMWgrFrUSaz?tk=Pwd03nE4md3')
      } else {
        window.open(
          'https://detail.tmall.com/item.htm?app=chrome&bxsign=scdEgtk_EvTx7tDbdjUu5BOK0wBpFY0yu-O7T5auGVioYQiOj01R550Lw9Aztam0bk2zmnSlL_Ij4Q99VtHmekGtn8hVuuR1ywG-QBvPJMq5WL-NFSGDiJ7VsTzWCAhSWKK&cpp=1&id=837078145080&price=2799-2999&shareUniqueId=28932724424&share_crt_v=1&shareurl=true&short_name=h.gxtSaMWgrFrUSaz&sourceType=item&sp_tk=UHdkMDNuRTRtZDM%3D&spm=a2159r.13376460.0.0&suid=E419AC75-8A6E-4960-9AB2-D437D9673FEF&tbSocialPopKey=shareItem&tk=Pwd03nE4md3&un=84d3eaf4aaf1ed4e8bcc5a13b9bc225d&un_site=0&ut_sk=1.YqDabOfEoQoDAGIiywyTUm3O_21380790_1729932887020.Copy.1&wxsign=tbwRF8hvcNwoUT31sw8EG3LOupMzAY2a9KOyOp25e-W1p2wXcAnEFur607dBHl2_Kijj67mfzgkEDIUdPLGyqPhrU5J_MHOtXrM7_PtNsGXTsYF5j7xVOc4C3x11Uj3g9oi'
        )
      }
    },
    openJDFun () {
      if (this._isMobile()) {
        window.open('https://3.cn/270W-MNG')
      } else {
        window.open('https://item.jd.com/10117681222331.html')
      }
    },
    //   download android
    async downloadAndroidFun () {
      this.num += 1
      try {
        await axios
          .get(`${NEW_API_URL}/api/package/spark`, {
            headers: {
              //   'Authorization': `JWT ${this.token || window.localStorage.getItem('PG_TOKEN')}`,
              'Content-Type': 'application/json;charset=UTF-8'
            }
          })
          .then((res) => {
            if (res.data.android) {
              let userAgent = navigator.userAgent.toLowerCase()
              if (
                userAgent.indexOf('android') > -1 &&
                                this.num > 1
              ) {
                window.open(res.data.android.download_url)
              } else {
                this.androidUrl = res.data.android.download_url
              }
            }
          })
          .catch((err) => {
            console.error('Fail!!', err)
          })
      } catch (err) {
        console.log(err, '请求出错！')
      }
    },
    // download ios
    downIosFun () {
      window.open('https://apps.apple.com/cn/app/id1516758668')
    }
  }
}
</script>
<style lang="scss" scoped>
.pc_ipad {
    display: block;
    padding-top: 54px;
}

.mobile {
    display: none;
}

.page {
    // padding-top: 5.5%;
    background: #fff;
    min-height: 100vh;

    .layer1 {
        display: flex;

        .left {
            flex: 1435;
            padding-right: 1%;

            .row {
                display: flex;
                width: 100%;
                box-sizing: border-box;
                margin-bottom: 10px;
                .video {
                    display: flex;
                    background: #000;
                }
                div:nth-child(1) {
                    margin-right: 1%;
                }

                div {
                    position: relative;
                    flex: 1;
                    max-width: 100%;

                    img,
                    video {
                        width: 100%;
                    }

                    .play {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        width: 20%;
                    }
                }
            }

            .row:nth-child(3) {
                margin: 0;
            }
        }

        .right {
            flex: 486;
            // background: #e02020;
            box-sizing: border-box;
            text-align: center;

            .box {
                margin: 0 auto;
                position: relative;

                .background {
                    width: 100%;
                }

                .right_btn_box {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 50%;
                    transform: translate(-50%, 0);
                    padding-top: 83%;

                    .price {
                        width: 80%;
                        margin-left: 10%;
                        margin-bottom: 10%;
                    }

                    .btn {
                        cursor: pointer;
                        // width: 100%;
                        margin-left: 6%;
                        height: 3%;
                    }
                    .btn_jd {
                        margin-top: 3%;
                    }
                    .download {
                        // opacity: 0;
                        margin-top: 6%;
                        margin-left: 6%;
                        width: 100%;
                        display: flex;
                    }
                    .download > * {
                        width: 35%;
                        margin-right: 5%;
                    }

                    .text {
                        margin: 0 auto;
                        margin-top: 8%;
                        width: 50%;
                    }
                }
            }
        }
    }

    .layer2 {
        position: relative;
        .video {
            position: absolute;
            bottom: 2%;
            right: 10%;
            display: flex;
            width: 40%;
            height: 12.1%;
            box-sizing: border-box;
            margin-bottom: 10px;

            div:nth-child(1) {
                margin-right: 1%;
            }

            img,
            video {
                width: 100%;
            }

            .play {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 20%;
            }
        }
    }

    .layer3 {
        // margin-top: -25%;
    }

    .layer4 {
        position: relative;
        padding: 7% 0;
        .swiper {
            // position: absolute;
            top: 17%;

            .swiper-slide {
                width: 33%;
            }

            .width {
                width: 3%;
            }
        }
    }
    .layer4_1 {
        background-color: #000;
    }

    .layer5 {
        position: relative;

        .swiper {
            position: absolute;
            top: 44%;

            .swiper-slide {
                width: 7%;
            }

            .width {
                width: 13%;
            }
        }
        .swiper2 {
            position: absolute;
            top: 69%;

            .swiper-slide {
                width: 17%;
            }

            .width {
                width: 13%;
            }
        }
    }

    .layer4,
    .layer5 {
        // background-color: #000;
    }

    .layer8 {
        position: relative;

        .swiper {
            position: absolute;
            top: 20%;

            .swiper-slide {
                width: 70%;
            }

            .width {
                width: 95%;
            }
        }
    }

    @media (max-width: 768px) {
        .pc_ipad {
            display: none;
        }

        .mobile {
            min-height: 100%;
            padding-top: 44px;
            background: #fff;
            display: block;

            .carousel {
                height: 100%;
                vertical-align: middle;
            }

            .layer2 > img {
                margin-top: -1px;
            }

            .layer2 {
                position: relative;
                text-align: center;

                .right_btn_box {
                    width: 100%;
                    position: absolute;
                    top: 65%;

                    .btn {
                        margin: 0 auto;
                        width: 56%;
                    }

                    .anzuo {
                        margin: 15% auto 0 auto;
                        width: 45%;
                    }

                    .ios {
                        margin: 3% auto 0 auto;
                        width: 45%;
                    }

                    .text {
                        margin: 3% auto 0 auto;
                        width: 25%;
                    }
                }

                .tmall {
                    padding: 5%;
                    position: absolute;
                    top: 64.5%;
                    // background-color: #000;
                    // width: 46%;
                    height: 5%;
                }
                .jd {
                    top: 71%;
                }

                .anzuo {
                    position: absolute;
                    top: 88.5%;
                    left: 7%;
                    // background-color: #fff;
                    width: 40%;
                    height: 10%;
                }

                .ios {
                    position: absolute;
                    top: 88.5%;
                    right: 7%;
                    // background-color: #fff;
                    width: 40%;
                    height: 10%;
                }

                .video {
                    position: absolute;
                    bottom: 0%;
                    left: 4%;
                    width: 92%;
                }
                .swiper2moblie {
                    position: absolute;
                    max-width: 100%;
                    bottom: 10%;
                }
            }
            .layer8moblie {
                margin-top: 10%;
            }
            .swiper1 {
                background: #000;
                .swiper-container {
                    background-color: #000;
                }
                .width {
                    width: 0%;
                }
            }

            .layer3 {
                margin-top: 0%;
                position: relative;

                .play {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 20%;
                }
            }
            .layer14 {
                position: relative;
                .swiper {
                    position: absolute;
                    top: 28%;
                    .swiper-slide {
                        width: 80%;
                    }

                    .width {
                        width: 6%;
                    }
                }
            }
            // .layer4{
            //   img{
            //     width:100%;
            //   }
            // }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/spark2.vue